import React from 'react';
import { Container } from 'react-bootstrap';


function Footer() {
    return (
        <Container className="page-footer" fixed="bottom" fluid>
            <footer >
                <Container className="">
                    <a href="https://www.instagram.com/moonozdisenoz/" target="_blank" rel="noreferrer">
                        <i className="fab fa-instagram fa-2x"></i>
                    </a>
                </Container>

            </footer>
        </Container>

    );
}

export default Footer;
